module.exports = __webpack_public_path__ + "static/media/Manual_Maker_App_Translation_Product.e5649ea2.png";